module.exports = __webpack_public_path__ + "img/Raspberry64_48.20118b82.png";